import Modal from '.';
import AuthChoices from '../buttons/auth-choices';
// import SendOtp from '@/components/auth/login/mobile-login/send-otp';
import OtpVerification from '@/components/auth/forget-password/send-otp';
import ResetPassword from '@/components/auth/forget-password/reset-password';
import Register from '@/components/auth/register/Register';
import EmailLogin from '@/components/auth/login/email-login';
import { useState } from 'react';
import VerifyMobileOtp from '@/components/auth/login/mobile-login/VerifyMobileOtp';
import { useTranslations } from 'next-intl';
import ForgotEmail from '@/components/auth/forget-password/forgot-email';
import ForgotMobile from '@/components/auth/forget-password/forgot-mobile';

const AuthModal = ({ auth, setAuth }) => {
  // used to save mobile number or email for verify otp
  const [verifyOtpForValue, setVerifyOtpForValue] = useState({});
  const t = useTranslations('common');
  const handleVerifyOtpValue = (object) => {
    setVerifyOtpForValue(object);
  };
  return (
    <Modal
      isOpen={!!auth}
      onClose={() => setAuth(false)}
      title={
        auth
          ? auth?.includes('-')
            ? t(auth?.split('-')?.[0])
            : auth == 'register'
              ? t('SignUp')
              : t(auth)
          : ''
      }
      maxWidth='max-sm:max-w-80 lg:max-w-2xl max-md:max-w-md max-lg:max-w-xl'
      headerTitleClassName='py-1.5 md:py-3 px-3 lg:px-8 max-md:py-2.25'
      titleClassName='text-sm lg:text-xl max-lg:!font-bold max-md:text-base max-lg:text-base'
      closeClassName='max-lg:size-5'
    >
      {false &&
        !!auth &&
        auth !== 'otp' &&
        auth !== 'verify-login-mobile-otp' &&
        auth !== 'change-password' &&
        auth !== 'register' && (
          <AuthChoices
            name={auth?.split('-')?.[0]}
            auth={auth}
            t={t}
            setAuth={setAuth}
          />
        )}
      {auth === 'login-mobile' ? null : // <SendOtp
      //   setAuth={setAuth}
      //   t={t}
      //   onVerifyOtpValue={handleVerifyOtpValue}
      // />
      auth === 'login-email' ? (
        <EmailLogin setAuth={setAuth} t={t} />
      ) : auth === 'forgot-mobile' ? (
        <ForgotMobile
          setAuth={setAuth}
          t={t}
          onVerifyOtpValue={handleVerifyOtpValue}
        />
      ) : auth === 'forgot-email' ? (
        <ForgotEmail
          setAuth={setAuth}
          t={t}
          onVerifyOtpValue={handleVerifyOtpValue}
        />
      ) : auth === 'verify-login-mobile-otp' ? (
        <VerifyMobileOtp
          verifyOtpForValue={verifyOtpForValue}
          setAuth={setAuth}
          t={t}
        />
      ) : auth === 'otp' ? (
        <OtpVerification
          setAuth={setAuth}
          t={t}
          onVerifyOtpValue={handleVerifyOtpValue}
          verifyOtpForValue={verifyOtpForValue}
        />
      ) : auth === 'change-password' ? (
        <ResetPassword
          setAuth={setAuth}
          t={t}
          verifyOtpForValue={verifyOtpForValue}
        />
      ) : auth === 'register' ? (
        <Register setAuth={setAuth} t={t} />
      ) : null}
    </Modal>
  );
};

export default AuthModal;
